<template>
  <app-content
    :content="translate(block.getText('editor'))"
    :class="`editor__content--${layout}`"
    v-if="block.isShowed('text_editor')"
  />
</template>

<script setup>
import { defineAsyncComponent } from 'vue'
import { useI18n } from '@/vendors/i18n'

const AppContent = defineAsyncComponent(() => import('&/atoms/AppContent'))

const { column, block } = defineProps({
  column: { type: Object, required: true },
  block: { type: Object, required: true }
})

const { translate } = useI18n()

const layout = column.is_small ? 'compact' : 'normal'
</script>